<template lang="pug">
.col-6
  .row
    .col-12
      h3 
        i.fal.fa-info-circle
        | Настройка внутри заведения
    .col-12.white_block(v-if="!employee.find((x) => x.type == 20)")
      .not_found Сначала создайте сотрудника с правами "Раздатчика кодов"
        span Через него администратор заведения будет раздавать секретные ключи для входа.
    .col-12.white_block.how_to(v-else)
      h4 
        | Менеджер
        | — администратору заведения
      ul
        li Откройте браузер (Safari / Chrome) на планшете администратора.
        li Перейдите на нём по ссылке:
          a(href="https://inventory.actid.ru/manager/", target="_blank") https://inventory.actid.ru/manager/
        li Введите токен "Раздатчика кодов":
          br
          input-module(
            type="hidden_key",
            v-model="employee.find((x) => x.type == 20).token"
          )
      h4 
        | Бот
        | — сотруднику заведения
      ul
        li Установите на своё устройство Telegram.
        li Найдите бота:
          a(href="https://t.me/tobacco_inventory_bot", target="_blank") @tobacco_inventory_bot
        li Отправьте ему номер склада, указанный в Менеджере ({{ warehouse_id }}).
        li Отправьте ему секретный ключ (для каждого сотрудника он уникальный).
</template>

<script>
export default {
  props: ["employee", "warehouse_id"],
};
</script>

<style lang="scss" scoped>
.how_to {
  a {
    color: #3f51b5;
    margin-left: 5px;

    &:hover {
      color: black;
    }
  }

  ul {
    list-style: decimal;
  }
}

.not_found {
  cursor: default;
  text-align: center;
  padding: 20px 0;

  span {
    color: gray;
    display: block;
    margin-top: 5px;
  }
}

h3 {
  .fa-info-circle {
    color: #808080;
    margin-right: 5px;
    font-size: 20px;
    position: relative;
    top: -2px;
  }
}
</style>

<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  .how_to a {
    color: #6e84ff;

    &:hover {
      color: white;
    }
  }
}
</style>